import APP_CONST from '@/constants/AppConst'
import APP_UTILITIES from '@/utilities/commonFunctions'

export const guardianEmergencyInformation = {
  getEmergencyInfo: () => {
    const date: any = new Date()
    const key = new Date().getTime() + '_' + Math.ceil(Math.random() * 88888)
    const states: any = APP_UTILITIES.getStatesShortFinalList(APP_CONST.COUNTRY_ID)

    return [
      {
        group: 'emergencyContactsDetails',
        type: 'emergencyContact',
        name: 'emergencyContact',
        dropIndex: 0,
        elmType: 'emergencyGrid',
        title: 'Emergency Contact',
        label: 'Emergency Contact',
        columns: [
          {
            span: 24,
            list: [
              {
                type: 'sectionHeader',
                name: 'textAreaLongQuestion',
                dropIndex: 0,
                elmType: 'single',
                options: {
                  width: '100%',
                  defaultValue:
                    'Emergency Contacts must be unique from Guardians. Programs will reach out to Emergency Contacts only when Guardians are unavailable.',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: 'Type description here',
                  disabled: false
                },
                key: key + '_textAreaLongQuestion',
                model:
                  'textAreaLongQuestion' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [],
                isDrag: true,
                isEditable: false
              },
              {
                type: 'dividerLine',
                name: 'dividerLine',
                title: 'Divider Line',
                leftSideTitle: 'Divider Line',
                elmType: 'single',
                dropIndex: 0,
                options: {
                  width: '100%',
                  defaultValue: '',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: '',
                  disabled: false
                },
                key: key + '_dividerLine',
                model:
                  'dividerLine' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [],
                isDrag: true,
                isEditable: false,
                required: false
              },
              {
                type: 'select',
                name: 'emergency_callorder',
                title: 'Call Order',
                label: 'Emergency Contact Call Order',
                elmType: 'single',
                dropIndex: 0,
                dropdownStatus: false,
                options: {
                  defaultValue: '',
                  multiple: false,
                  disabled: true,
                  clearable: false,
                  placeholder: 'Select',
                  required: false,
                  showLabel: false,
                  width: '',
                  options: [
                    {
                      value: '1'
                    },
                    {
                      value: '2'
                    },
                    {
                      value: '3'
                    },
                    {
                      value: '4'
                    },
                    {
                      value: '5'
                    }
                  ],
                  remote: false,
                  filterable: false,
                  remoteOptions: [],
                  props: {
                    value: 'value',
                    label: 'label'
                  },
                  remoteFunc: ''
                },
                key: key + '_emergency_call_order',
                model:
                  'emergency_call_order' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [
                  {
                    required: true,
                    message: 'This field is required. (Es necesario llenar este espacio.)'
                  }
                ],
                isDrag: false,
                isEditable: false
              },
              {
                type: 'guardianEmergencyContact',
                name: 'emergencyContactName',
                title: 'Name',
                elmType: 'grid',
                label: 'Emergency Contact Name',
                dropIndex: 0,
                columns: [
                  {
                    span: 12,
                    list: [
                      {
                        type: 'input',
                        name: 'emergency_firstname',
                        title: 'First Name',
                        options: {
                          width: '100%',
                          defaultValue: '',
                          required: false,
                          dataType: 'string',
                          pattern: '',
                          placeholder: 'First Name',
                          disabled: false,
                          maxlength: 50
                        },
                        key: key + '_emergency_firstname',
                        model:
                          'emergency_firstname' +
                          '_' +
                          new Date().getTime() +
                          '_' +
                          Math.ceil(Math.random() * 88888),
                        rules: [
                          { type: 'string', message: 'First Name Invaild format' },
                          {
                            required: true,
                            message: 'This field is required. (Es necesario llenar este espacio.)'
                          },
                          {
                            pattern: "/^[a-zA-Z '-]+$/",
                            message:
                              'Use only letters, hyphens, and apostrophes in the name field. Other special characters, including accents, are not supported. (Por ahora, en el campo de nombre usa solo letras, guiones y apóstrofes. No se admiten otros caracteres especiales, incluidas las tildes, las eñes (ñ), etc.)'
                          },
                          {
                            min: 0,
                            max: 50,
                            message: 'Firstname must be 0 to 50 charactors',
                            trigger: 'blur'
                          }
                        ],
                        isDrag: false,
                        isEditable: false
                      }
                    ]
                  },
                  {
                    span: 12,
                    list: [
                      {
                        type: 'input',
                        name: 'emergency_lastname',
                        title: 'Last Name',
                        options: {
                          width: '100%',
                          defaultValue: '',
                          required: false,
                          dataType: 'string',
                          pattern: '',
                          placeholder: 'Last Name',
                          disabled: false,
                          maxlength: 50
                        },
                        key: key + '_emergency_lastname',
                        model:
                          'emergency_lastname' +
                          '_' +
                          new Date().getTime() +
                          '_' +
                          Math.ceil(Math.random() * 88888),
                        rules: [
                          { type: 'string', message: 'Last Name Invaild format' },
                          {
                            required: true,
                            message: 'This field is required. (Es necesario llenar este espacio.)'
                          },
                          {
                            pattern: "/^[a-zA-Z '-]+$/",
                            message:
                              'Use only letters, hyphens, and apostrophes in the name field. Other special characters, including accents, are not supported. (Por ahora, en el campo de nombre usa solo letras, guiones y apóstrofes. No se admiten otros caracteres especiales, incluidas las tildes, las eñes (ñ), etc.)'
                          },
                          {
                            min: 0,
                            max: 50,
                            message: 'Last Name must be 0 to 50 charactors',
                            trigger: 'blur'
                          }
                        ],
                        isDrag: false,
                        isEditable: false
                      }
                    ]
                  }
                ],
                options: {
                  gutter: 0,
                  justify: 'start',
                  align: 'top'
                },
                key: key + '_emergencyContact',
                model:
                  'emergencyContact' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 88888),
                rules: [],
                isDrag: false,
                isEditable: false,
                required: false
              },
              {
                type: 'phoneNumberType',
                name: 'emergencyPhoneNumberType',
                title: 'Phone Number',
                elmType: 'grid',
                label: 'Emergency Contact Phone Number',
                dropIndex: 0,
                columns: [
                  {
                    span: 12,
                    list: [
                      {
                        type: 'input',
                        name: 'emergency_phone',
                        title: 'Phone',
                        elmType: 'single',
                        label: 'Phone Number',
                        dropIndex: 0,
                        options: {
                          width: '100%',
                          defaultValue: '',
                          required: false,
                          dataType: 'string',
                          pattern: '',
                          placeholder: 'Enter Number',
                          disabled: false,
                          maxLength: 14
                        },
                        key: key + '_emergency_phoneNumber',
                        model:
                          'emergency_phoneNumber' +
                          '_' +
                          new Date().getTime() +
                          '_' +
                          Math.ceil(Math.random() * 99999),
                        rules: [
                          {
                            required: true,
                            message: 'This field is required. (Es necesario llenar este espacio.)'
                          },
                          {
                            min: 14,
                            max: 14,
                            message: 'Phone number must be of 10 digits',
                            trigger: 'blur'
                          }
                        ],
                        isDrag: false,
                        isEditable: false
                      }
                    ]
                  },
                  {
                    span: 12,
                    list: [
                      {
                        type: 'select',
                        name: 'emergency_phonetype',
                        title: 'Type',
                        elmType: 'single',
                        dropdownStatus: false,
                        options: {
                          defaultValue: 'Select',
                          multiple: false,
                          disabled: false,
                          clearable: false,
                          placeholder: '',
                          required: false,
                          showLabel: false,
                          width: '100%',
                          options: [
                            {
                              value: 'Cell'
                            },
                            {
                              value: 'Work'
                            },
                            {
                              value: 'Home'
                            }
                          ],
                          remote: false,
                          filterable: false,
                          remoteOptions: [],
                          props: {
                            value: 'value',
                            label: 'label'
                          },
                          remoteFunc: ''
                        },
                        key: key + '_emergency_phoneNumber_type',
                        model:
                          'emergency_phoneNumber_type' +
                          '_' +
                          new Date().getTime() +
                          '_' +
                          Math.ceil(Math.random() * 99999),
                        rules: [],
                        isDrag: false,
                        isEditable: false
                      }
                    ]
                  }
                ],
                options: {
                  gutter: 0,
                  justify: 'start',
                  align: 'top'
                },
                key: key + '_emergencyPhoneNumberType',
                model:
                  'emergencyPhoneNumberType' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [],
                isDrag: false,
                isEditable: false,
                required: false
              },
              {
                type: 'dropdown',
                name: 'emergency_relation',
                title: 'Relationship to Child',
                label: 'Emergency Contact Relationship to Child',
                elmType: 'custom',
                dropIndex: 0,
                dropdownStatus: false,
                options: {
                  defaultValue: 'Select',
                  multiple: false,
                  disabled: false,
                  clearable: false,
                  placeholder: '',
                  required: false,
                  showLabel: false,
                  width: '',
                  isHide: false,
                  options: [
                    {
                      value: 'Mother'
                    },
                    {
                      value: 'Father'
                    },
                    {
                      value: 'Grandparent'
                    },
                    {
                      value: 'Others'
                    }
                  ],
                  remote: false,
                  filterable: false,
                  remoteOptions: [],
                  props: {
                    value: 'value',
                    label: 'label'
                  },
                  remoteFunc: ''
                },
                key: key + '_emergency_relationship',
                model:
                  'emergency_relationship' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [
                  {
                    required: true,
                    message: 'This field is required. (Es necesario llenar este espacio.)'
                  }
                ],
                isDrag: false,
                isEditable: false,
                required: false
              }
            ]
          }
        ],
        options: {
          gutter: 0,
          justify: 'start',
          align: 'top'
        },
        key: key + '_emergencyContactDetails',
        model:
          'emergencyContactDetails' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [],
        isDrag: true,
        isEditable: false,
        isHide: false
      }
    ]
  }
}
